// src/views/LimiteCredito/VerLimite.jsx
import React, { useEffect, useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { apiFetchJson } from "../../../utils/http";

export default function VerLimite({ id, onClose = null }) {
  const [data, setData] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (id == null) return;

    setCargando(true);
    setError("");

    apiFetchJson(apiRoutes.limiteCredito.detail(id), true)
      .then(setData)
      .catch((e) => {
        console.error("Error al cargar datos de límite:", e);
        setError("No se pudieron cargar los datos del límite.");
      })
      .finally(() => setCargando(false));
  }, [id]);

  const fmtMonto = (v) =>
    v == null ? "-" : Number(v).toLocaleString("es-ES");

  const fmtFecha = (v) => {
    if (!v) return "-";

    // Intentar parsear por si en algún momento viene en ISO
    const d = new Date(v);
    if (!Number.isNaN(d.getTime())) {
      return d.toLocaleString("es-PY");
    }

    // Si no es una fecha válida para JS (ej: "19-ene-2023 00:00:00"),
    // devolver el texto tal cual viene del backend
    return String(v);
  };


  return (
    <>
      {/* Encabezado */}
      <div className="modal-header">
        <h2 className="section-title">Datos de límite</h2>
      </div>

      {/* Contenido */}
      <div className="modal-body">
        {cargando ? (
          <div className="text-center py-12">Cargando...</div>
        ) : error ? (
          <div className="text-red-600 text-center py-12">Error: {error}</div>
        ) : !data ? (
          <div className="text-center py-12">Sin datos</div>
        ) : (
          <div className="form-grid">
            {[
              ["Cliente", data.clienteNombre],
              ["Estado", data.estadoNombre],
              ["Usuario solicitud", data.codigoUsuarioSolicitud],
              ["Valor monto solicitado", fmtMonto(data.valorMontoSolicitado)],
              ["Fecha de solicitud", fmtFecha(data.dataFechaSolicitud)],
              ["Motivo de solicitud", data.textoMotivoSolicitud],
              ["Usuario aprobación", data.codigoUsuarioAprobacion],
              ["Valor monto aprobado", fmtMonto(data.valorMontoAprobado)],
              ["Valor límite anterior", fmtMonto(data.valorLimiteAnterior)],
              ["Fecha aprobación", fmtFecha(data.dataFechaAprobacion)],
              ["Motivo rechazo", data.textoMotivoRechazo],
            ].map(([label, val]) => (
              <Fila key={label} label={label} value={val} />
            ))}
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="modal-footer">
        <div className="flex justify-end">
          <button onClick={onClose} className="btn-fil">
            Nueva consulta
          </button>
        </div>
      </div>
    </>
  );
}

function Fila({ label, value }) {
  return (
    <div className="form-row">
      <div className="form-label">{label}:</div>
      <div className="value">{value ?? "-"}</div>
    </div>
  );
}
